module.exports = __webpack_public_path__ + "media/images/agria_banner-8e7a78fad3a197792911fa40ca3e60bb.jpg";